import { createStyles, makeStyles } from '@material-ui/core';
import { theme } from '@nask/theme';

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    caseLink: {
      color: theme.typography.linkColor,
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    userInactive: {
      color: theme.colors.danger,
    },
    exclamationIcon: {
      color: '#ce3694',
    },
    tooltip: {
      fontSize: theme.typography.descriptionFontSize,
    },
  })
);
